import { makeArrowButtons, makeKeyPad, makeRightButtons } from "./all-sport";
import clock from "./clock";
import { registerElement } from "./guidance";
import {
    group,
    join,
    makeButton
} from "./svg-buttons";


export function allSport5000(): void {
    makeKeyPad();
    makeArrowButtons();
    makeRightButtons();

    // HOME
    const homeDefs = { color: "gray", borderColor: "darkgreen" };

    const homeScorePlus1 = makeButton({
        x: 0,
        y: 0,
        t: "SCORE\n+1",
        onClick: () => clock.onScoreHome(1),
        ...homeDefs,
    });
    registerElement("HOME_SCORE_PLUS1", homeScorePlus1);
    const homeScoreMinus1 = makeButton({
        x: 1,
        y: 0,
        t: "SCORE\n-1",
        onClick: () => clock.onScoreHome(-1),
        ...homeDefs,
    });
    registerElement("HOME_SCORE_MINUS1", homeScoreMinus1);
    const homeTimeOut = makeButton({
        x: 2,
        y: 0,
        t: "TIME OUT\n&larr;",
        onClick: () => clock.onTimeoutHome(),
        ...homeDefs,
    });

    const homeShotsOnGoalPlus1 = makeButton({
        x: 0,
        y: 1,
        t: "SHOTS\nON\nGOAL\n+1",
        onClick: () => clock.onShotsHome(1),
        ...homeDefs,
    });
    registerElement("HOME_SHOTS_PLUS1", homeShotsOnGoalPlus1);
    const homeShotsOnGoalMinus1 = makeButton({
        x: 1,
        y: 1,
        t: "SHOTS\nON\nGOAL\n-1",
        onClick: () => clock.onShotsHome(-1),
        ...homeDefs,
    });
    registerElement("HOME_SHOTS_MINUS1", homeShotsOnGoalMinus1);

    const homeSavesPlus1 = makeButton({
        x: 0,
        y: 2,
        t: "SAVES\n+1",
        ...homeDefs,
    });
    const homeSavesMinus1 = makeButton({
        x: 1,
        y: 2,
        t: "SAVES\n-1",
        ...homeDefs,
    });
    const homePenalty = makeButton({
        x: 2,
        y: 2,
        t: "PENALTY\n&larr;",
        ...homeDefs,
    });

    const homePlayerPenalty = makeButton({
        x: 0,
        y: 3,
        t: "PLAYER\nPENALTY\n&bull;",
        onClick: () => clock.onHomePlayerPenalty(),
        ...homeDefs,
    });
    registerElement("HOME_PLAYER_PENALTY", homePlayerPenalty);
    const homeDeletePenalty = makeButton({
        x: 1,
        y: 3,
        t: "DELETE\nPENALTY\n&bull;",
        onClick: () => clock.onDeleteHomePenalty(),
        ...homeDefs,
    });
    registerElement("HOME_DELETE_PENALTY", homeDeletePenalty);
    const homeClearAllPenalties = makeButton({
        x: 2,
        y: 3,
        t: "CLEAR\nALL\nPENALTIES\n&bull;",
        onClick: () => clock.onClearAllHomePenalties(),
        ...homeDefs,
    });
    registerElement("HOME_CLEAR_ALL_PENALTIES", homeClearAllPenalties);

    group(homeScorePlus1, homeClearAllPenalties, "HOME", homeDefs.borderColor);
    join(homeScorePlus1, homeScoreMinus1, homeDefs.borderColor);
    join(homeShotsOnGoalPlus1, homeShotsOnGoalMinus1, homeDefs.borderColor);
    join(homeSavesPlus1, homeSavesMinus1, homeDefs.borderColor);
    join(homePlayerPenalty, homeDeletePenalty, homeDefs.borderColor);

    // SECTION II
    const miscDefs = { color: "gray", borderColor: "black" };
    const recallShotTime = makeButton({
        x: 3,
        y: 0,
        t: "RECALL\nSHOT\nTIME",
        ...miscDefs,
    });
    const setShotTime = makeButton({
        x: 4,
        y: 0,
        t: "SET\nSHOT\nTIME",
        ...miscDefs,
    });
    const timeOutOnOff = makeButton({
        x: 5,
        y: 0,
        t: "TIME OUT\nON/OFF",
        onClick: () => clock.onTimeoutOnOff(),
        ...miscDefs,
    });

    const enablePenaltyClocks = makeButton({
        x: 4,
        y: 1,
        t: "ENABLE\nPENALTY\nCLOCKS",
        onClick: () => clock.setEnablePenaltyClocks(true),
        ...miscDefs,
    });
    const disablePenaltyClocks = makeButton({
        x: 5,
        y: 1,
        t: "DISABLE\nPENALTY\nCLOCKS",
        onClick: () => clock.setEnablePenaltyClocks(false),
        ...miscDefs,
    });

    const minorPenalty = makeButton({
        x: 4,
        y: 2,
        t: "MINOR\nPENALTY",
        ...miscDefs,
    });
    const majorPenalty = makeButton({
        x: 5,
        y: 2,
        t: "MAJOR\nPENALTY",
        ...miscDefs,
    });

    const periodPlus1 = makeButton({
        x: 5,
        y: 3,
        t: "PERIOD\n+1",
        onClick: () => clock.onPeriod(),
        ...miscDefs,
    });
    registerElement("PERIOD_PLUS1", periodPlus1);

    join(recallShotTime, setShotTime, miscDefs.borderColor);
    join(enablePenaltyClocks, disablePenaltyClocks, miscDefs.borderColor);
    join(minorPenalty, majorPenalty, miscDefs.borderColor);

    // GUEST
    const guestDefs = { color: "gray", borderColor: "darkred" };

    const guestScorePlus1 = makeButton({
        x: 7,
        y: 0,
        t: "SCORE\n+1",
        onClick: () => clock.onScoreGuest(1),
        ...guestDefs,
    });
    registerElement("GUEST_SCORE_PLUS1", guestScorePlus1);
    const guestScoreMinus1 = makeButton({
        x: 8,
        y: 0,
        t: "SCORE\n-1",
        onClick: () => clock.onScoreGuest(-1),
        ...guestDefs,
    });
    registerElement("GUEST_SCORE_MINUS1", guestScoreMinus1);
    const guestTimeOut = makeButton({
        x: 9,
        y: 0,
        t: "TIME OUT\n&rarr;",
        onClick: () => clock.onTimeoutGuest(),
        ...guestDefs,
    });

    const guestShotsOnGoalPlus1 = makeButton({
        x: 7,
        y: 1,
        t: "SHOTS\nON\nGOAL\n+1",
        onClick: () => clock.onShotsGuest(1),
        ...guestDefs,
    });
    registerElement("GUEST_SHOTS_PLUS1", guestShotsOnGoalPlus1);
    const guestShotsOnGoalMinus1 = makeButton({
        x: 8,
        y: 1,
        t: "SHOTS\nON\nGOAL\n-1",
        onClick: () => clock.onShotsGuest(-1),
        ...guestDefs,
    });
    registerElement("GUEST_SHOTS_MINUS1", guestShotsOnGoalMinus1);

    const guestSavesPlus1 = makeButton({
        x: 7,
        y: 2,
        t: "SAVES\n+1",
        ...guestDefs,
    });
    const guestSavesMinus1 = makeButton({
        x: 8,
        y: 2,
        t: "SAVES\n-1",
        ...guestDefs,
    });
    const guestPenalty = makeButton({
        x: 9,
        y: 2,
        t: "PENALTY\n&rarr;",
        ...guestDefs,
    });

    const guestPlayerPenalty = makeButton({
        x: 7,
        y: 3,
        t: "PLAYER\nPENALTY\n&bull;",
        onClick: () => clock.onGuestPlayerPenalty(),
        ...guestDefs,
    });
    registerElement("GUEST_PLAYER_PENALTY", guestPlayerPenalty);
    const guestDeletePenalty = makeButton({
        x: 8,
        y: 3,
        t: "DELETE\nPENALTY\n&bull;",
        onClick: () => clock.onDeleteGuestPenalty(),
        ...guestDefs,
    });
    registerElement("GUEST_DELETE_PENALTY", guestDeletePenalty);
    const guestClearAllPenalties = makeButton({
        x: 9,
        y: 3,
        t: "CLEAR\nALL\nPENALTIES\n&bull;",
        onClick: () => clock.onClearAllGuestPenalties(),
        ...guestDefs,
    });
    registerElement("GUEST_CLEAR_ALL_PENALTIES", guestClearAllPenalties);

    group(
        guestScorePlus1,
        guestClearAllPenalties,
        "GUEST",
        guestDefs.borderColor
    );
    join(guestScorePlus1, guestScoreMinus1, guestDefs.borderColor);
    join(guestShotsOnGoalPlus1, guestShotsOnGoalMinus1, guestDefs.borderColor);
    join(guestSavesPlus1, guestSavesMinus1, guestDefs.borderColor);
    join(guestPlayerPenalty, guestDeletePenalty, guestDefs.borderColor);
}
